<template>
  <div id="footer">
    Copyright &copy; {{currentYear}} crisedgar.com
  </div>
</template>

<script>

export default {
  name: 'footer',
  data: function() {
    var date = new Date();
    var year =  date.getFullYear()
    return { currentYear: year}
  }
}



</script>

<style>
#footer {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
